import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=8f515a70&scoped=true&"
import script from "./Staffs.vue?vue&type=script&lang=js&"
export * from "./Staffs.vue?vue&type=script&lang=js&"
import style0 from "./Staffs.vue?vue&type=style&index=0&id=8f515a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f515a70",
  null
  
)

export default component.exports